module.exports = __webpack_public_path__ + "static/img/02450_7.a93bde0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_7.jpg
// module id = 5jwv
// module chunks = 1